import React, { useState } from "react";
import "./Home.css";
import SalesChart from "./SalesChart";
import { useNavigate } from "react-router-dom";
import APIService from "../../Service/APIService";
import TitleBar from "../../common/title-bar/title-bar.js";
import { timeframeButtons } from "../Utils/Constants.js";
import CommonCard from "../../common/card/index.js";
import CommonButton from "../../common/button/button.js";
import CommonText from "../../common/typography/text.js";
import { useScreen } from "../Utils/Screens.js";
import SmallCard from "../../common/card/small-card/small-card.js";
import Divider from "../../common/divider/divider.js";
import { useAuth } from "../AuthProvider";

const Home = () => {
  const { user } = useAuth();
  const [totalSalesYTD, setTotalSalesYTD] = React.useState(0);
  const [totalSalesMTD, setTotalSalesMTD] = React.useState(0);
  const [totalOpenBalance, setTotalOpenBalance] = React.useState(0);
  const [totalPastDue, setTotalPastDue] = React.useState(0);
  const [SalesYTDAccountsCount, setSalesYTDAccountsCount] = React.useState(0);
  const [SalesMTDAccountsCount, setSalesMTDAccountsCount] = React.useState(0);
  const [activeDistributorsCount, setActiveDistributorsCount] =
    React.useState(0);
  const [activeDistributorsCountMTD, setActiveDistributorsCountMTD] =
    React.useState(0);
  const [TotalOpenBalanceAccountsCount, setTotalOpenBalanceAccountsCount] =
    React.useState(0);
  const [TotalPastDueAccountsCount, setTotalPastDueAccountsCount] =
    React.useState(0);
  const [TotalCurrentSalesYTD, setTotalCurrentSalesYTD] = React.useState(0);
  const [TotalCurrentSalesMTD, setTotalCurrentSalesMTD] = React.useState(0);
  const [regionData, setRegionData] = React.useState(null);
  const [userType, setUserType] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [filterButton, setFilterButton] = useState("YTD");

  const isPhone = !useScreen("sm");

  const handleFilterButtonChange = (value) => {
    setFilterButton(value);
  };

  const YTDSales = filterButton === "YTD";
  const [realizedSalesInvoicesCountMTD, setRealizedSalesInvoicesCountMTD] =
    React.useState(0);
  const [realizedSalesInvoicesCountYTD, setRealizedSalesInvoicesCountYTD] =
    React.useState(0);

  const getHomeDashboardData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("homedashboarddata");
    console.log("Home Dashboard Data: ", response?.data?.data);
    return response?.data?.data;
  };

  
  React.useEffect(() => {
    console.log("Home component mounted");
    console.log("user data:", user);
    const userData = user;
    setUserType(userData?.Type);
    // Account, Distributor and Manufacturer users never see this dashboard: redirect
    // before fetching so the admin-wide sales query is not run for them.
    if (userData && userData.Type === "Account") {
      navigate(`/Account/${userData.AccountID}`);
      window.location.reload();
      return;
    } else if (userData && userData.Type === "Distributor") {
      navigate(`/Distributor/${userData.DistributorID}`);
      window.location.reload();
      return;
    } else if (userData && userData.Type === "Manufacturer") {
      navigate(`/Manufacturer/${userData.ManufacturerID}`);
      window.location.reload();
      return;
    }
    getHomeDashboardData()
      .then((data) => {
        console.log("Home Dashboard Data: ", data);
        setTotalSalesYTD(data?.TotalSalesYTD);
        setTotalSalesMTD(data?.TotalSalesMTD);
        setTotalOpenBalance(data?.TotalOpenBalance);
        setTotalPastDue(data?.TotalOpenBalancePastDueDate);
        setSalesYTDAccountsCount(data?.SalesYTDAccountsCount);
        setSalesMTDAccountsCount(data?.SalesMTDAccountsCount);
        setTotalOpenBalanceAccountsCount(data?.TotalOpenBalanceAccountsCount);
        setTotalPastDueAccountsCount(data?.TotalPastDueAccountsCount);
        setTotalCurrentSalesYTD(data?.TotalCurrentSalesYTD);
        setTotalCurrentSalesMTD(data?.TotalCurrentSalesMTD);
        setActiveDistributorsCount(data?.DistributorCount);
        setActiveDistributorsCountMTD(data?.DistributorCountMTD);
        setRealizedSalesInvoicesCountMTD(data?.RealizedSalesInvoicesCountMTD);
        setRealizedSalesInvoicesCountYTD(data?.RealizedSalesInvoicesCountYTD);
        console.log("Region Data: ", data?.RegionData);
        const regionMap = new Map();
        data?.RegionData?.forEach((item) => {
          regionMap.set(item?.RegionName, item);
        });
        setRegionData(regionMap);
      })
      .then(() => {
        setLoading(false);
      });
    // Mount-only: redirect by user type once, then load the admin dashboard.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();

  const regionDataMapper = [
    [
      {
        topText: "East",
        topIndicatorVariant: "blue",
        topNumber: YTDSales
          ? `${parseFloat(
              regionData?.get("East")?.SalesPercentage
            ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`
          : `${parseFloat(
              regionData?.get("East")?.SalesPercentageMTD
            ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
        cardTitle: "Current Sales",
        cardTitleValue: YTDSales
          ? `${parseFloat(
              regionData?.get("East")?.CurrentSalesYTD
            ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`
          : `${parseFloat(
              regionData?.get("East")?.CurrentSalesMTD
            ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
        cardBottomNumber: YTDSales
          ? regionData?.get("East")?.AccountCount
          : regionData?.get("East")?.AccountCountMTD,
        cardBottomName: "Accounts",
      },
      {
        cardTitle: "Realized Sales",
        cardTitleValue: YTDSales
          ? parseFloat(
              regionData?.get("East")?.SalesYTD
            ).toLocaleString("en-US", { maximumFractionDigits: 2 })
          : parseFloat(
              regionData?.get("East")?.SalesMTD
            ).toLocaleString("en-US", { maximumFractionDigits: 2 }),
        cardBottomNumber: YTDSales
          ? regionData?.get("East")?.AccountCount
          : regionData?.get("East")?.AccountCountMTD,
        cardBottomName: "Accounts",
      },
      {
        title: "Active Accounts",
        number: YTDSales
          ? regionData?.get("East")?.AccountCount
          : regionData?.get("East")?.AccountCountMTD,
      },
      {
        title: "Active Distributors",
        number: YTDSales
          ? regionData?.get("East")?.DistributorCount
          : regionData?.get("East")?.DistributorCountMTD,
      },
    ],
    // [
    //   {
    //     topText: "Central",
    //     topIndicatorVariant: "blue",
    //     topNumber: YTDSales
    //       ? `${parseFloat(
    //           regionData?.get("Central")?.SalesPercentage
    //         ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`
    //       : `${parseFloat(
    //           regionData?.get("Central")?.SalesPercentageMTD
    //         ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
    //     cardTitle: "Current Sales",
    //     cardTitleValue: YTDSales
    //       ? `${parseFloat(
    //           regionData?.get("Central")?.CurrentSalesYTD
    //         ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`
    //       : `${parseFloat(
    //           regionData?.get("Central")?.CurrentSalesMTD
    //         ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
    //     cardBottomNumber: YTDSales
    //       ? regionData?.get("Central")?.AccountCount
    //       : regionData?.get("Central")?.AccountCountMTD,
    //     cardBottomName: "Accounts",
    //   },
    //   {
    //     cardTitle: "Realized Sales",
    //     cardTitleValue: YTDSales
    //       ? parseFloat(
    //           regionData?.get("Central")?.SalesYTD
    //         ).toLocaleString("en-US", { maximumFractionDigits: 2 })
    //       : parseFloat(
    //           regionData?.get("Central")?.SalesMTD
    //         ).toLocaleString("en-US", { maximumFractionDigits: 2 }),
    //     cardBottomNumber: YTDSales
    //       ? regionData?.get("Central")?.AccountCount
    //       : regionData?.get("Central")?.AccountCountMTD,
    //     cardBottomName: "Accounts",
    //   },
    //   {
    //     title: "Active Accounts",
    //     number: YTDSales
    //       ? regionData?.get("Central")?.AccountCount
    //       : regionData?.get("Central")?.AccountCountMTD,
    //   },
    //   {
    //     title: "Active Distributors",
    //     number: YTDSales
    //       ? regionData?.get("Central")?.DistributorCount
    //       : regionData?.get("Central")?.DistributorCountMTD,
    //   },
    // ],
    [
      {
        topText: "West",
        topIndicatorVariant: "blue",
        topNumber: YTDSales
          ? `${parseFloat(
              regionData?.get("West")?.SalesPercentage
            ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`
          : `${parseFloat(
              regionData?.get("West")?.SalesPercentageMTD
            ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
        cardTitle: "Current Sales",
        cardTitleValue: YTDSales
          ? `${parseFloat(
              regionData?.get("West")?.CurrentSalesYTD
            ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`
          : `${parseFloat(
              regionData?.get("West")?.CurrentSalesMTD
            ).toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
        cardBottomNumber: YTDSales
          ? regionData?.get("West")?.AccountCount
          : regionData?.get("West")?.AccountCountMTD,
        cardBottomName: "Accounts",
      },
      {
        cardTitle: "Realized Sales",
        cardTitleValue: YTDSales
          ? parseFloat(
              regionData?.get("West")?.SalesYTD
            ).toLocaleString("en-US", { maximumFractionDigits: 2 })
          : parseFloat(
              regionData?.get("West")?.SalesMTD
            ).toLocaleString("en-US", { maximumFractionDigits: 2 }),
        cardBottomNumber: YTDSales
          ? regionData?.get("West")?.AccountCount
          : regionData?.get("West")?.AccountCountMTD,
        cardBottomName: "Accounts",
      },
      {
        title: "Active Accounts",
        number: YTDSales
          ? regionData?.get("West")?.AccountCount
          : regionData?.get("West")?.AccountCountMTD,
      },
      {
        title: "Active Distributors",
        number: YTDSales
          ? regionData?.get("West")?.DistributorCount
          : regionData?.get("West")?.DistributorCountMTD,
      },
    ],
  ];

  // const runHubspotStop = async () => {
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "This will stop the ongoing sync from Hubspot to Tissue Vault.",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, stop it!'
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       const apiServe = new APIService();
  //       const response = await apiServe.addDataToBackend({}, "stophubspotsync");
  //       if (response?.status === 200) {
  //         Swal.fire(
  //           'Sync Stopped!',
  //           'The Hubspot sync has been stopped successfully.',
  //           'success'
  //         );
  //         console.log("Hubspot Sync Response: ", response);
  //       }
  //       else {
  //         Swal.fire(
  //           'Error!',
  //           'There was an error stopping the Hubspot sync.',
  //           'error'
  //         );
  //       }
  //     }
  //   });
  // }

  // const runHubspotRevert = async () => {
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "This will revert the last sync from Hubspot to Tissue Vault. This process may take several minutes.",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, revert it!'
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       const apiServe = new APIService();
  //       const response = await apiServe.addDataToBackend({}, "reverthubspotsync");
  //       if (response?.status === 200) {
  //         Swal.fire(
  //           'Revert Started!',
  //           'The Hubspot revert has been initiated successfully.',
  //           'success'
  //         );
  //         console.log("Hubspot Sync Response: ", response);
  //       }
  //       else {
  //         Swal.fire(
  //           'Error!',
  //           'There was an error initiating the Hubspot revert.',
  //           'error'
  //         );
  //       }
  //     }
  //   });
  // }

  // const runIndividualSync = async () => {
  //   const apiServe = new APIService();
  //   const response = await apiServe.addDataToBackend({}, "runhubspotcompanysync?hubspotCompanyId=219829232374");
  //   console.log("Hubspot Sync Response: ", response);
  // }

  // const revertIndividualSync = async () => {
  //   const apiServe = new APIService();
  //   const response = await apiServe.addDataToBackend({}, "reverthubspotcompanysync");
  //   console.log("Hubspot Sync Response: ", response);
  // }

  // const runHubspotSync = async () => {
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "This will sync data from Hubspot to Tissue Vault. This process may take several minutes. You will receive an email on completion.",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, sync it!'
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       const apiServe = new APIService();
  //       const response = await apiServe.addDataToBackend({}, "runhubspotsync?limit=25000");
  //       if (response?.status === 200) {
  //         Swal.fire(
  //           'Sync Started!',
  //           'The Hubspot sync has been initiated successfully.',
  //           'success'
  //         );
  //         console.log("Hubspot Sync Response: ", response);
  //       }
  //       else {
  //         Swal.fire(
  //           'Error!',
  //           'There was an error initiating the Hubspot sync.',
  //           'error'
  //         );
  //       }
  //     }
  //   });
  // }

  return (

    // old with flex
    <div
      style={{
        display: "grid",
        gap: "32px",
      }}
    >
      <TitleBar
        label="Dashboard"
        rightFilterBarComponents={
          <>
            <CommonText variant="buttonText">Timeframe</CommonText>
            {timeframeButtons.map((btn) => {
              return (
                <CommonButton
                  key={btn}
                  isActive={filterButton === btn}
                  variant="timeframe"
                  onClick={() => handleFilterButtonChange(btn)}
                >
                  {btn}
                </CommonButton>
              );
            })}
          </>
        }
      />
      <div
        className="dashboard-container"
        style={isPhone ? { flexDirection: "column" } : { flexDirection: "row" }}
      >
        <div
          style={
            isPhone
              ? {
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }
              : {
                  display: "flex",
                  flexDirection: "column",
                  width: "75%",
                  // height: "100%", // changed from fill-available
                  // backgroundColor: "red",
                  padding: "24px 16px 0px 16px", // change bottom padding back to 16px post the chart fill-available fix
                  border: "1px solid var(--strokeLight)",
                  boxShadow: "0px 4px 20px 0px rgba(38, 99, 235, 0.1)",
                  borderRadius: "16px",
                  gap: "16px",
                }
          }
        >
          {/* <Card bordered={false} bodyStyle={{ padding: "0px 10px 0px 10px" }}>
            <SalesChart isYearlySales={YTDSales} />
          </Card> */}
          {/* <Card bordered={false} bodyStyle={{ padding: "0px 10px 0px 10px" }}> */}
          <CommonText variant="bodyText">Realized Sales by Month</CommonText>
          <SalesChart isYearlySales={YTDSales} />
          {/* </Card> */}
        </div>
        <div className="home-card-wrapper">
          <CommonCard
  loading={loading}
  cardTitle="Current Sales"
  cardTitleValue={YTDSales ? TotalCurrentSalesYTD : TotalCurrentSalesMTD}
  cardBottomNumber={YTDSales ? SalesYTDAccountsCount : SalesMTDAccountsCount}
  cardBottomName="Active Accounts"
  hideSecondBottomBar
  secondBottomName="Active Distributors"
  secondBottomNumber={
    YTDSales ? activeDistributorsCount : activeDistributorsCountMTD
  }
/>

<CommonCard
  loading={loading}
  cardTitle="Realized Sales"
  cardTitleValue={YTDSales ? totalSalesYTD : totalSalesMTD}
  cardBottomNumber={
    YTDSales
      ? realizedSalesInvoicesCountYTD
      : realizedSalesInvoicesCountMTD
  }
  cardBottomName="Invoices"
  hideSecondBottomBar
/>

<CommonCard
  loading={loading}
  cardTitle="Total Open Balance"
  cardTitleValue={totalOpenBalance}
  cardBottomNumber={TotalOpenBalanceAccountsCount}
  cardBottomName="Invoices"
/>

<CommonCard
  loading={loading}
  cardTitle="Total Past Due"
  cardTitleValue={totalPastDue}
  cardTitleValueColor="failureColor"
  cardBottomNumber={TotalPastDueAccountsCount}
  cardBottomName="Invoices"
/>
        </div>
      </div>

      {/* bottom section */}
      <TitleBar
        label="Current Sales by Region"
        labelTextVariant="bodyText"
      />
      <div
        style={{
          gap: "32px",
          overflowX: "auto",
          scrollbarWidth: "none",
          paddingBottom: "32px",
        }}
      >
        <div
          style={{
            paddingBottom: "2px",
            paddingTop: "2px",
            paddingLeft: "2px",
            scrollbarWidth: "none",
          }}
        >
          <div
            style={{
              display: "flex",

              gap: "32px",
            }}
          >
            {(userType === "Admin" ||
              userType === "Authorizer" ||
              userType === "Viewer") && (
                <>
                  {regionDataMapper?.map((region, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                          gap: "32px",
                          paddingRight:
                            index === regionDataMapper.length - 1 ? "4px" : "0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "32px",
                          }}
                        >
                          <CommonCard
                            loading={loading}
                            topText={region[0].topText}
                            topNumber={`${region[0]?.topNumber?.toString()}%`}
                            topIndicatorVariant={region[0].topIndicatorVariant}
                            cardTitle={region[0].cardTitle}
                            cardTitleValue={region[0].cardTitleValue}
                            cardBottomNumber={region[0].cardBottomNumber}
                            cardBottomName={region[0].cardBottomName}
                          />
                          <CommonCard
                            loading={loading}
                            topText={region[1].topText}
                            topNumber={region[1].topNumber}
                            topIndicatorVariant={region[1].topIndicatorVariant}
                            cardTitle={region[1].cardTitle}
                            cardTitleValue={region[1].cardTitleValue}
                            cardBottomNumber={region[1].cardBottomNumber}
                            cardBottomName={region[1].cardBottomName}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "32px",
                            }}
                          >
                            <SmallCard
                              loading={loading}
                              title={region[2].title}
                              number={region[2].number}
                            />
                            <SmallCard
                              loading={loading}
                              title={region[3].title}
                              number={region[3].number}
                            />
                          </div>
                        </div>
                        {index < regionDataMapper.length - 1 ? (
                          <Divider page="dashboard" />
                        ) : (
                          <></>
                        )}
                      </div>
                    );
                  })}
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
